import { useEffect, useState } from "react";
import { Gizmo, gnov } from "flowy-3-core";
import styled from "styled-components";
import { Button as AButton } from "antd";
import { toast } from "react-toastify";
import { Modal } from "antd";
import axios from "axios";

const Button = styled(AButton)`
  marign: 5px 0;
  // width: 100%;
`;

type RegisterButtonProps = {
  gizmo: Gizmo;
};

const RegisterButton = ({ gizmo }: RegisterButtonProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const title = "Aviso de Privacidad";

  const handleButtonClick = async () => {
    setModalOpen(true);
  };

  const handleModalOk = async () => {
    window.location.href = "/#/sign_up";
  };
  const handleModalCancel = async () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleButtonClick} type="primary">
        Regístrate
      </Button>
      <Modal
        open={modalOpen}
        title={title}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
      >
        <p>
          La Secretaría de Bienestar del Estado de Quintana Roo, a través de la
          Dirección de Faro, informa que es la responsable del tratamiento de
          los datos personales recabados de usted, los cuales serán utilizados
          para Realizar la Solicitud de Inscripción al Programa, comprobar que
          cumple con los criterios de elegibilidad al Programa, y generar el
          Padrón de Personas Beneficiarias del Programa; asumiendo la obligación
          de cumplir con las medidas legales y de seguridad suficientes para
          proteger tales datos personales. Para mayor detalle consulte nuestro
          Aviso de Privacidad Integral en:{" "}
          <a
            target="_blank"
            href="https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/"
          >
            https://sebien.qroo.gob.mx/avisos-de-privacidad-de-la-sebien/
          </a>
          , en la sección “Avisos de privacidad”.{" "}
        </p>
      </Modal>
    </>
  );
};

export default RegisterButton;
